import services from './../../../services/service'; // Service Class
import MainHeader from './../../MainHeader/index.vue'; // Main Header
import MainFooter from './../../MainFooter/index.vue'; // Main Footer
import GalleryForm from './../../../components/posts/newgallery.vue'; // Add Gallery
import ProductGalleryForm from './../../../components/posts/newproductgallery.vue'; // Add Product Gallery

let service = new services();

export default {
    name: 'Sellpoint',
    data () {
        return {
            user:{},
            market:{},
            sellpoint:{},
            categories:{},
            galleria:{},
            gallery:{},
            gallery_post:{},
            gallery_post_set_image:{},
            post:{},
            products: {},
            product: {},
            productMain:{},
            productItem:{},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn:false,
            edit_mode:false,
            loading: true,
            online: false,
            place_order: false,
            ordered_product: {},
            ordered_product_item:{},
            swipe_index: 0, // two way

            data_error_message: "",
            data_success_message: "",
            data_processing_message:"",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name:"",
            payment_payer_email:"",
            payment_payer_phone:"",
            payment_service:"",
            
            addPanel:false,
            business_load_error_msg:"",
            newLookbookForm: false,
            newProductLookbookForm: false,
            max_plan_lookbooks:0,
            max_plan_lookbook_posts:0,
            total_lookbooks_added:0,
            can_add_more_lookbook:false,
            can_add_product_lookbook:false,
            addNewPost:false,
            file_info:{},
            refresh_button:false,
            disable_btn:false,
            action_loading:false,
            default_banner_image:"https://res.cloudinary.com/diprbfy7s/image/upload/v1550754799/businesses_files/sp-default-banner.jpg",
            set_sellpoint_banner_image: '',

            gallery_view:false,
            //mobil-swipe-handle .1
           //index:0, //two way

            //mobil-swipe-handle .2.
           swiperOption: {
            pagination: {
                el: '.swiper-pagination'
            }
            // navigation: {
            //     nextEl: '.swiper-button-next',
            //     prevEl: '.swiper-button-prev'
            // }
          },
          menu_view:{},
          menu_tab_view:{},
          chat_logs:{},
          chat_log:{},
          chat:{},
          active_chat:{},
          //
          business_posts:{},
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'add-lookbook': GalleryForm,
        'add-product-lookbook': ProductGalleryForm,
    },
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        }
    },
    methods: {
        ///
        setMenuComponent(view){
            this.menu_view = {};
            this.menu_view[view] = true;
            //unactivate
            var tabs = document.getElementsByClassName('tab-menu-link');
            for (var i = 0; i < tabs.length; i++) {
                tabs[i].style = "color:#000000;";
            } 
            document.getElementById(view).style.color = service.app_default_color;
            // if(view == "categories"){document.getElementById("m_categories").style.color = "#ff0066";}
            // if(view == "products"){document.getElementById("m_products").style.color = "#ff0066";}
            // if(view == "reviews"){document.getElementById("m_reviews").style.color = "#ff0066";}
        },

        setMenuTabView(view){
            this.menu_tab_view = {};
            this.menu_tab_view[view] = true;
        },

        ///
        mobileSideNavToggle(action){
            if(action == "open"){
                // document.getElementById("mobileSideNav").style.width = "300px";
               // document.getElementById("mobileSideNav").style.width = "50%";

                //if mobile
                // if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
                // || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
                //     document.getElementById("mobileSideNav").style.width = "100%";
                // }
                var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

                if (isMobile) {
                    document.getElementById("mobileSideNav").style.width = "100%";
                }else{
                    document.getElementById("mobileSideNav").style.width = "50%";
                }
            }
            if(action == "close"){
                document.getElementById("mobileSideNav").style.width = "0";
                // or //document.getElementById("mobileSideNav").style.display = "none";
            }
        },

        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        checkIfVideo(url){
            if(url != undefined){
                let ext = url.split('.').pop();
                if(service.video_exts.includes(ext)){
                    return true;
                }else{
                    return false;
                }
            }
        },

        addComponent(attr1,attr2){
           
            this.addPanel = true;
                
            if(attr1 == "add-new-lookbook"){
                this.newLookbookForm = true;
            }
            if(attr1 == "add-new-product-lookbook"){
                this.newProductLookbookForm = true;
            }
            if(attr1 == "add-new-product-post"){
                //change this url to accomodate product
                this.$router.push("/"+this.$route.params.id+"/"+this.gallery.gallery_posts_group_url_name)
               // $('#quickviewModal').modal('hide');
                //then call
                this.newProductLookbookForm = true;
            }
            if(attr1 == "add-new-post"){
                this.addNewPost = true;
               // $('#quickviewModal').modal('hide');
                this.gallery = attr2;

            }
            
            //ifopen sidebar if closed and gallery_view is on turn off
            if(this.gallery_view){
                //turn off
                this.gallery_view = false;
                //open side bar
                // this.mobileSideNavToggle("open");
                let self = this;
                setTimeout(function(){ self.mobileSideNavToggle("open"); }, 150)
            }

            //make page to jump to specific location
            // document.getElementById("addPanelView").scrollIntoView(); //general addPanelView otherwise use specific names

            //BETTER - srolls to the very top
            var top = document.getElementById("addPanelView").offsetTop; //Getting Y of target element //general addPanelView otherwise use specific names
            window.scrollTo(0, top); 
        },

        setComponent(attr1,attr2){
            if(attr1 == "refresh-store"){
                this.getGalleryPosts();
            }
            if(attr1 == "close-gallery-view"){
                this.gallery_view = false;
            }
        },

        reset(){
            // document.getElementById("yuyu").style.width = "300px";
            this.addPanel = false,
            this.addNewPost = false;
            this.newLookbookForm = false;
            this.newProductLookbookForm = false;
            this.data_error_message = "";
            this.data_success_message = "";
        },

        preset_xtra() {
            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;//loggedIn options
                            //set sellpoint and seller options
                           this.is_editing();
                        }, this);
                    }else {
                      //  console.log(response)
                     //// this.$router.push('/login/');
                      }
                }).catch((err) => {
                    if(err) {
                        // console.log(err)
                        //this.$router.push('/login/');
                    }
                })
            }else {
               //console.log("error 2")
              // this.$router.push('/login/');
            }
        },

        
        preset() {
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.user.user_name = value.user_name;
                    self.is_editing();
                    self.getChatLogs();//run first
                    self.getChatLog();//run first
                    setTimeout(function(){ 
                        self.loadChatLogs();
                    }, 30000);
                    // self.getChatLogs();

                    self.loading = false;
                }else {
                    self.$router.push('login');
                }
            });
        },

        is_editing(){ //preseting if seller
            if(this.user.user_id != ""){
                var payload = {
                    validate_user: this.user.user_id,
                    validate_business: this.sellpoint.business_id
                }
                service.can_edit(this, payload).then(response => {
                    if(response.body.status == 200) {
                        this.edit_mode =  true;
                        // this.can_edit = true;
                    }else {
                        this.edit_mode =  false;
                    }
                }).catch((err) => {
                    if(err) {
                        //log error
                    }
                })
            }
        },

        setGallery(){
            this.loading = true;
            service.getGallerySearch(this, this.$route.params.id).then(response => {
                if(response.body.status == 200) {
                    this.gallery = response.body.data;

                    // this.preset();
                    this.loading = false;
                }
            }).catch((err) => {
               // console.log(err)
             //   this.redir(this.$route.params.id1); //go to sellpoint
                //log it
                //location.replace("/")
            })
        },

        setSellpointXX(){ 
            this.loading = true;
            service.getAppBusinessByUserName(this, this.$route.params.id).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint = response.body.data; 
                    document.title = this.sellpoint.business_name + " | " + service.app_name;
                    //this.getProductsInBusinessCategories(); // if basic sellpoint
                    this.getSellpointProducts(); // if basic sellpoint
                    //store or restore in localforage

                   //set the banner image 
                   if((this.sellpoint.business_banner_image == this.default_banner_image) || (this.sellpoint.business_banner_image == 'error')){
                       //assign market general banner image
                        //this.set_sellpoint_banner_image = service.general_banner_image; //use default inline color for now //for fast loading till //reset
                        this.set_sellpoint_banner_image = service.general_banner_image; 
                   }else{
                       //use the sellpoints banner image
                       this.set_sellpoint_banner_image = this.sellpoint.business_banner_image;
                   }
                    
                    //dummy settings
                    if(this.sellpoint.business_market_subscription_name == 'Bird Plan'){
                        this.max_plan_lookbooks = 2;
                        this.max_plan_lookbook_posts = 5;
                    }
                    if(this.sellpoint.business_market_subscription_name == 'Mid Bird Plan'){
                        this.max_plan_lookbooks = 10;
                        this.max_plan_lookbook_posts = 50; //unlimited
                    }
                    if(this.sellpoint.business_market_subscription_name == 'Max Bird Plan'){
                        this.max_plan_lookbooks = 50;//unlimited
                        this.max_plan_lookbook_posts = 50;//unlimited
                        this.can_add_product_lookbook = true; //online shop functionality
                    }
                    
                    
                    let self = this;
                    setTimeout(function(){ self.getGalleryPosts(); }, 3000); //wait for 3sec and call posts in gallery
                    this.preset();
                    this.loading = false;
                }else{
                    this.business_load_error_msg = "Sorry, this Business Information could not be found.";
                }
            }).catch((err) => {
                this.loading = false;
                //move
                //maybe no connection ..load from local
               // this.setSellpointLocal(); //removed...caused slower loading
            })
            
        },

        setSellpoint(){ 
            this.loading = true;
            service.getAppBusinessByUserName(this, this.$route.params.id).then(response => {
                if(response.body.status == 404) {
                    //move to //404
                    this.$router.push("buzz"); //add params to //use as //404
                }else if(response.body.status == 200) {
                    this.sellpoint = response.body.data; 
                    this.preset();
                    document.title = this.sellpoint.business_name + " | " + service.app_name;
                    //this.getProductsInBusinessCategories(); // if basic sellpoint
                    this.getSellpointProducts(); // if basic sellpoint
                    this.getSellpointPosts(); //
                    //store or restore in localforage

                    //set the banner image 
                    if((this.sellpoint.business_banner_image == this.default_banner_image) || (this.sellpoint.business_banner_image == 'error')){
                        //assign market general banner image
                        //this.set_sellpoint_banner_image = service.general_banner_image; //use default inline color for now //for fast loading till //reset
                        this.set_sellpoint_banner_image = service.general_banner_image; 
                    }else{
                        //use the sellpoints banner image
                        this.set_sellpoint_banner_image = this.sellpoint.business_banner_image;
                    }
                    
                    
                }else{
                    this.business_load_error_msg = "Sorry, this Business Information could not be found.";
                }
            }).catch((err) => {
                this.loading = false;
                //move
                //maybe no connection ..load from local
               // this.setSellpointLocal(); //removed...caused slower loading
            })
            
        },

        getSellpointProducts(){
            this.loading = true;
            service.getBusinessProducts(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                    this.loading = false;
                }
            }).catch((err) => {})
        },

        getSellpointPosts(){
            this.loading = true;
            service.getXPosts(this, 2, this.sellpoint.business_id, 0, 50).then(response => {
                if(response.body.status == 200) {
                    this.business_posts = response.body.data;
                    this.loading = false;
                }
            }).catch((err) => {})
        },

        getProductsInBusinessCategories(){
            this.loading = true;
            service.getProductsInBusinessCategories(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) { 
                    this.categories = response.body.data;
                }
                this.loading = false;
            }).catch((err) => {
                this.loading = false;
            })
        },

        //followings

        followSellpoint(){
            this.activate_processing();
            var payload = {
                following_user: this.user.user_id,
                following_type: 1, //business
                following_module: 3, //business
                following_module_id: this.sellpoint.business_id,
            }
          
            let navi = this.$router;
            if((payload.following_module != undefined)) {
                service.addFollowing(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_processing_message = "Followed";
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    this.data_processing_message =  "Something went wrong";
                    this.deactivate_processing();
                })
            }else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }

        },


        followPost(post){
            this.activate_processing();
            var payload = {
                following_user: this.user.user_id,
                following_type: 3, //event
                following_module: 6, //post
                following_module_id: post.post_id,
            }
          
            let navi = this.$router;
            if((payload.following_module != undefined)) {
                service.addFollowing(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_processing_message = "Followed";
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    this.data_processing_message =  "Something went wrong";
                    this.deactivate_processing();
                })
            }else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }

        },

        //posts
        postComment(){

        },

        //chats
        loadChatLogs(){
            let self = this;
            if(self.edit_mode){
                setInterval(function(){
                    self.getChatLogs();
                }, 30000);
            }else{
                setInterval(function(){
                    self.getChatLog();
                }, 30000);
            }
        },

        loadCurrentChatLog(ini){ //redo
            let self = this;
            setInterval(function(){
                service.getChatLog(self, self.sellpoint.business_id, ini).then(response => {
                    if(response.body.status == 200) { 
                        self.chat_log = response.body.data;
                    }
                }).catch((err) => {
                    self.loading = false;
                })
            }, 10000);
        },

        setChatLog(chat_to,chat_log){
            this.active_chat.chat_to = chat_to;
            this.active_chat.chat_ini = chat_to;
            this.chat_log = chat_log;
            this.loadCurrentChatLog(this.active_chat.chat_ini); //redo
        },

        getChatLogs(){
            this.loading = true;
            let chat_module = 3; //businesses
            service.getChatLogs(this, chat_module, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) { 
                    this.chat_logs = response.body.data;
                }
                this.loading = false;
            }).catch((err) => {
                this.loading = false;
            })
        },

        getChatLog(){ //btn sp and initiator
            this.loading = true;
            let chat_module = 3; //businesses
            service.getChatLog(this, chat_module, this.sellpoint.business_id, this.user.user_id).then(response => {
                if(response.body.status == 200) { 
                    this.chat_log = response.body.data;
                }
                this.loading = false;
            }).catch((err) => {
                this.loading = false;
            })
        },

        postChatObject(product){
            this.chat.chat_message_type = 8;
            this.chat.chat_message_object = product.product_id;
            this.chat.chat_message_object_product_name = product.product_name;
            this.chat.chat_message_object_product_price = product.product_items[0].product_item_price_f;
            this.chat.chat_message_object_product_url_name = product.product_url_name;
            this.chat.chat_message_object_product_image = product.product_images[0].product_image;
            this.postChat();
        },

        postChat(){
            this.chat.chat_message = this.chat.chat_set_message;
            this.chat.chat_set_message = ""; //free text field
            this.activate_processing();
            if(this.edit_mode){
                // this.chat.chat_to=this.sellpoint.business_id;
                this.active_chat.chat_from=this.sellpoint.business_id;
                this.active_chat.chat_from_point_module=3;//businesses
                this.active_chat.chat_to_point_module=1;//users
            }else{
                this.active_chat.chat_ini = this.user.user_id;
                this.active_chat.chat_to=this.sellpoint.business_id;
                this.active_chat.chat_from=this.user.user_id;
                this.active_chat.chat_from_point_module=1;//users
                this.active_chat.chat_to_point_module=3;//businesses
            }
            var payload = {
                chat_module: 3, //businesses
                chat_module_id: this.sellpoint.business_id,
                chat_ini: this.active_chat.chat_ini,
                chat_type: 0,
                chat_from: this.active_chat.chat_from,
                chat_to: this.active_chat.chat_to,
                chat_message: this.chat.chat_message || "",
                chat_message_type: this.chat.chat_message_type || 0,
                chat_message_object: this.chat.chat_message_object || 0,
                chat_message_object_product_name: this.chat.chat_message_object_product_name || "",
                chat_message_object_product_price: this.chat.chat_message_object_product_price || 0,
                chat_message_object_product_url_name: this.chat.chat_message_object_product_url_name || "",
                chat_message_object_product_image: this.chat.chat_message_object_product_image || "",
            }
            // (payload.chat_message == undefined) || (payload.chat_message == "") && 
            if(((payload.chat_message == "") && (payload.chat_message_object == 0))){
                this.data_processing_message = "Nothing Sent";
                this.deactivate_processing();
            }else{
                service.postChat(this, payload).then(function(data) {
                    if((data.body.status == 201) || (data.body.status == 200)) {
                        this.chat_log = data.body.data;
                        this.chat = {}; //reload
                        this.setMenuTabView("");
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    //log it
                    this.delivery_option = {};
                    this.deactivate_processing();
                })
            }
        },
        ////

        getGalleryPosts(){
            this.loading = true;
            service.getPointGalleryPosts(this, this.sellpoint.business_id,0,this.max_plan_lookbooks,0,this.max_plan_lookbook_posts).then(response => {
                // if(response.body.status != 400) {
                    this.galleria = response.body.data;
                    //settings
                    this.total_lookbooks_added = response.body.total_data;

                    if(this.total_lookbooks_added < this.max_plan_lookbooks){
                        this.can_add_more_lookbook = true;
                    }
                //}
                this.loading = false;
            }).catch((err) => {
                this.loading = false;
            })
        },

        getPostsInGallery(gallery){
            this.gallery = gallery;
            this.gallery_post = gallery.gallery_posts_group_posts[0];
            // this.gallery_post_set_image = gallery.gallery_posts_group_posts[0].gallery_post_media;
            
            if(this.gallery_post.gallery_post_media[0]){
                this.gallery_post_set_image = this.gallery_post.gallery_post_media[0];
            }else{
                this.gallery_post_set_image = {};
            }
            // this.gallery_post_set_image = this.gallery_post.gallery_post_media[0];
            
            
            this.gallery_view = true;
            //  setTimeout(function(){ 
            //     var top = document.getElementById("galleryview").offsetTop; 
            //     window.scrollTo(0, top); 
            // }, 400);
            // $('#quickviewModal').modal('show');
        },
      
        getCategoryProducts(category){
            this.loading = true;
            this.product = category.business_category_products[0];
            this.products = category.business_category_products;
            $('#quickviewModal').modal('show');
            this.loading = false;
            
        },

        getCategoryProductsXX(category){
            this.loading = true;
            let self = this;
            service.getCategoryProducts(this, category).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                    // this.product = this.products;
                    
                    // this.viewAllProductsBanner = true;
                    // this.showSidebarMobile = false;
                    //ist one
                    let count = 0;
                    this.products.forEach(element => {
                        count++;
                        if(count == 1){
                            this.product = element;
                            $('#quickviewModal').modal('show');
                        }
                       
                    });
                    this.loading = false;
                }
            }).catch((err) => {
                this.loading = false;
            })
        },

        showPost(post){
            this.gallery_post = post;
            
            // this.gallery_post_set_image = post.gallery_post_media[0];

            if(this.gallery_post.gallery_post_media[0]){
                this.gallery_post_set_image = this.gallery_post.gallery_post_media[0];
            }else{
                this.gallery_post_set_image = {};
            }
        },
       
        showPostImage(post_image){
            this.gallery_post_set_image = post_image;
        },
        


        showProduct(product){
            this.product = product;
        },

        addPostToGallery(){
            this.activate_processing();
            // this.disable_btn = true;
            //this.business.agree = true;
            var credentials = {
                gallery_new_group: false,
                gallery_post_group: this.gallery.gallery_posts_group_id, 
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details,
            }
          
            let navi = this.$router;
            if(credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        //toastr.success("Post Created", 'Success!');
                        this.data_success_message = "Post Created";
                        //log user in
                        this.post = data.body.data;
                        
                        //add image
                        //let result = data.body.data;
                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type","gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(data => {
                            if(data.body.status == 200){
                            location.reload(true);
                            this.gallery = data.body.data_gallery;
                            this.addNewPost = false;
                            }
                            this.deactivate_processing();
                        }).catch((err) => {
                                if(err) {
                                // log it
                                //console.log(err)
                                }
                            //toastr.warning("Something went wrong.", 'Warning!');
                            this.data_error_message = "Something went wrong";
                            this.deactivate_processing();
                        })
                        //if uploading takes time continue with reload
                        let self = this;
                        setTimeout(function(){  location.reload(true); }, 2000); //wait for 1min and timeout

                        //navi.push("/"+this.$route.params.id+"/"+this.product.product_url_name); //changed for now, info on banner

                        
                    }
                }).catch((err) => {
                    if(err) {
                       // toastr.warning("Something went wrong", 'Warning!'); 
                        this.data_error_message = "Something went wrong";
                       // console.log(err)
                        this.disable_btn = false;
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },

        //uploads
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {   
                this.file_info = files;
                let formData = new FormData();
                formData.append('photo', files[0]); 
                this.imageForm = formData;
            }   
        
        },

        onFileChangeBannerImage(e,type) {
            this.activate_processing();
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', this.sellpoint.business_id); 
                formData.append('data_type', type); 
                service.uploadBusinessDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                        if(type == "business_banner_image"){
                            this.sellpoint.business_banner_image = data.body.data;
                            this.set_sellpoint_banner_image = this.sellpoint.business_banner_image;
                        }
                        if(type == "business_brand_image"){
                            this.sellpoint.business_brand_image = data.body.data;
                        }
                        //wait and reset
                        let self = this;
                        setTimeout(function(){ 
                            //close the sidebar after one sec
                            self.deactivate_processing();
                            self.mobileSideNavToggle('close');
                            //load a bit more to set the image
                            self.loading = true;
                            setTimeout(function(){ 
                                self.loading = false;
                            }, 1200);
                        }, 1000);
                        // this.deactivate_processing();
                    }else{
                        this.data_error_message = "Could not update, something went wrong. Please try again";
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    this.data_error_message = "Could not update, something went wrong. Please try again";
                    this.deactivate_processing();
                })
            }   
                
        },

        manageLookbook(){
            this.disable_btn = true;
            //get auth key
            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.app_url,
                request_from: service.app_name,
                request_status: "REQUESTING...",
                request: this.sellpoint.business_username+'/g/'+this.gallery.gallery_posts_group_url_name,
            } 
            if(credentials.session_key != null) {
                //save session and request on server
                service.sessionSync(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        //redirect to sp with session ref
                        let ref = response.body.data;
                        window.location.href = service.sp_url+'/manage/'+ref;
                    }else{
                        this.disable_btn = false;
                    }
                }).catch((err) => {
                    if(err) {
                       // console.log(err)
                        this.disable_btn = false;
                       // this.$router.push('/login/');
                    }
                })
            }
        },


        addToCart (productMain,productItem) {
            this.productItem = {}; //refresh hook
            const cart_index = this.cart.findIndex(c => c.product_item_id === productItem.product_item_id) //best removal
            if(cart_index < 0){
                // if(this.cart.indexOf(productItem) < 0){
                this.productMain = productMain;
                this.productItem = productItem;
                this.productItem._id = this.productItem.product_item_id;
                this.productItem.is_product_in_cart = true; 
                //config qty if not set
                if(this.productItem.product_item_order_quantity == undefined){
                this.productItem.product_item_order_quantity = 1;
                }
                this.productItem.product_main_id = this.productMain.product_id;
                this.productItem.product_business = this.productMain.product_business_ownername;
                this.productItem.product_name = this.productMain.product_name;
                this.productItem.product_url_name = this.productMain.product_url_name;
                this.productItem.product_url = this.productMain.product_business_ownername+"/"+this.productMain.product_url_name;
                this.$store.commit(ADD_TO_CART, this.productItem);
                //this.productItem.is_product_in_cart = true; 
               // $('#quickviewModal').hide()
            }else{
               // console.log("in cart")
            }
            
        },
          // removeFromCart (id) {
          //   this.$store.commit(REMOVE_FROM_CART, id)
          // },
        removeFromCart (payload) {
            this.$store.commit(REMOVE_FROM_CART, payload)
        },

        ///buy order

        //
        placeOrder(product,product_item){
            this.ordered_product = product;
            this.ordered_product_item =  product_item;
            this.place_order = true;
        },
        resetOptions(){
            this.ordered_product = {};
            this.ordered_product_item = {};
            this.total_price = 0;
            this.place_order = false;
        },


        //connect to a payment gateway
        processPayment() {
            //test data
            let data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            let phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if((email_test == false) || (this.payment_payer_name == " ") || (phone_test == false)){
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            }else{
                data_test = true;
                this.data_error_message = "";
            }
            if(data_test){
                 //process online payment
                    this.payment_service = "HungrillvilleKitchen Order - " + this.ordered_product.product_name+"("+this.ordered_product_item.product_item_price+")";
                    let obj = this;
                    //this.amount_paid = data.plan_amount;
                    var handler = PaystackPop.setup({
                    // key: 'pk_live_64fe633bf8a53b0346ef8a44f54dc41cc0aa9f8b',
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,
                    // email: data.plan_user_email || "admin@sellpoints.ng",
                    email: this.payment_payer_email,
                    amount:  (Math.round(this.ordered_product_item.product_item_price * 100)),//(data.plan_amount * 100), //in kobo
                    ref: "HUNGLOG"+Math.random(),
                    metadata: {
                        custom_fields: [
                            {
                                display_name: "HungrillvilleKitchen Order",
                                variable_name: "",
                                value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.ordered_product.product_name
                            },
                            {
                                display_name: "Service",
                                variable_name: "service_type",
                                value: this.ordered_product.product_name
                            }
                            
                        ]
                    },
                    
                    callback: function(response){
                        obj.updatePayment(response.trxref); 
                    },
                    onClose: function(){
                        alert('window closed');
                    }
                    });
                    handler.openIframe();
                }

        },

        // update payments
        updatePayment(payment_ref) {

            // var payload = {
            //     payment_order_ref: payment_ref,
            //     payment_user_id: this.user.user_id
            // }
            let navi = this.$router;

            let payer_name = this.payment_payer_name; 
            this.data = {}
            //$('#buy-modal').modal('hide');
            this.payment_successful = true;
            this.payment_successful_message = "Hi "+payer_name+", Your Payment was successful, we would proceed to prepare your order. Thank You."

        },

        //buy order

        //mobil-swipe-handle
        handleResize() {
            this.$refs.swipe.reset();
        },
        
    },
    mounted (){
    //   this.preset();
    
      //set color for active tab menu
      document.getElementById("welcomeView").style.color = "#ff0066";
      this.menu_view["welcomeView"] = true; //set landing view
      
    },
    
    created: function(){
        this.menu_view["products"] = true;
        //reset gallery url redirect
        if(this.$route.params.idg){
            this.$router.push('/'+this.$route.params.id)
        }
        if(this.addPanel){
            this.refresh_button = true;
        }
        this.reset();
        this.setSellpoint();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Sellpoint/Sellpoint/script.js